import { Button, Card, CardActions, CardContent, Container, Grid, Switch as MuiSwitch, Typography, CircularProgress, TextField as MuiTextField } from '@mui/material'
import { Box } from '@mui/system'
import React, { useRef } from 'react'
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState, useCallback } from 'react';
import { Formik, Form, Field } from "formik";
import { Select, TextField } from 'formik-mui';
import * as Yup from 'yup';
import useAxiosPrivate from '../../hooks/use-axios-private';
import { Switch } from 'formik-mui';
import { alertMsg } from '../../utils/basicUtils';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useTheme } from '@emotion/react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Menu from '@mui/material/Menu';
import { BRAND_NAME } from '../../constants';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FormControlLabel } from '@mui/material';
import Empty from '../../components/Empty';
import Popup from '../../components/Popup';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import StrictNumberField from '../../components/StrictNumberField';

const WorkSample = ({ item, onDelete, checkBoxChange, isChecked, isTransferring }) => {
	const axios = useAxiosPrivate();
	const theme = useTheme()
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [sampleImageTitle, setSampleImageTitle] = useState(item.title)
	const [check, setCheck] = useState(false)
	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleDisableBox = () => {
		setCheck(true)
	}

	const updateSampleImage = async () => {
		const updateImage = {
			'title': sampleImageTitle,
			'description': '',
		}
		try {
			const resp = await axios.put(`settings/save_work_sample_details/${item.id}`, updateImage)
			alertMsg(resp.data.message, "success")
			setCheck(false)
			setAnchorEl(null)

		}
		catch (err) {
			console.error(err)
		}
	}

	return (
		< Grid item xs={12} sm={6} md={3} sx={{ paddingLeft: { xs: "8px !important", sm: "24px !important" } }}>
			<Box sx={{}}>
				<Box sx={{ position: "relative" }}>

					{/* {!item.id &&
						<Box sx={{ borderRadius: '5px', width: 156, height: "156px", background: "#e5e8f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
							<CircularProgress />
						</Box>
					} */}

					<Box>
						<img style={{ borderRadius: '5px', width: "100%", height: "200px", objectFit: "cover" }}
							src={item.media.url}
							alt="Sample Images"
							loading="lazy"
						/>

					</Box>
					{!isTransferring &&
						<>
							<FormGroup className='checkbox-pad' sx={{ position: 'absolute', top: "0px", left: "0px", background: theme.palette.mode === "dark" ? "#5a5a5ac7" : "#ebecf0", borderRadius: "0 0 15px 0" }}>
								<FormControlLabel
									sx={{ m: 0, padding: "0px" }}
									control={<Checkbox
										checked={isChecked}
										onChange={(e) => { checkBoxChange(e) }}
									/>}
								/>
							</FormGroup>
							<Box sx={{ position: "absolute", top: "10px", right: "10px" }}>
								<div>
									{check === true
										?
										<IconButton
											size='small'
											aria-label="account of current user"
											aria-controls="menu-appbar"
											aria-haspopup="true"
											onClick={updateSampleImage}
											color="inherit"
											sx={{ backgroundColor: '#e8ebff', borderRadius: '4px', '&:hover': { backgroundColor: '#e8ebff' } }}
										>
											<EditOutlinedIcon color='primary' />
										</IconButton>
										:
										<>
											<IconButton
												size='small'
												aria-label="account of current user"
												aria-controls="menu-appbar"
												aria-haspopup="true"
												onClick={handleMenu}
												color="primary"
												sx={{ backgroundColor: '#e8ebff', borderRadius: '4px', '&:hover': { backgroundColor: '#e8ebff' } }}

											>
												<MoreVertIcon color='primary' />
											</IconButton>
											<Menu
												id="menu-appbar"
												anchorEl={anchorEl}
												anchorOrigin={{
													vertical: 'top',
													horizontal: 'right',
												}}
												keepMounted
												transformOrigin={{
													vertical: 'top',
													horizontal: 'right',
												}}
												open={Boolean(anchorEl)}
												onClose={handleClose}
											>
												<MenuItem onClick={handleDisableBox}>Edit</MenuItem>
												<MenuItem onClick={onDelete}>Delete</MenuItem>

											</Menu>
										</>
									}

								</div>

							</Box>
						</>
					}
				</Box>
				{check === true ?
					<Box sx={{ mt: 2 }}>
						<MuiTextField
							fullWidth
							label="Title"
							variant="outlined"
							value={sampleImageTitle}
							onChange={(e) => setSampleImageTitle(e.target.value)}

						/>
					</Box>
					:
					<Box sx={{ p: 2, mt: 2, borderRadius: "6px", backgroundImage: theme.palette.mode === "dark" ? "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))" : "none", bgcolor: theme.palette.mode === "dark" ? "background.dark" : "#fff", boxShadow: theme.palette.mode === "dark" ? "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)" : "0" }}>
						<Typography>{sampleImageTitle ? sampleImageTitle : "No Title"}</Typography>
					</Box>
				}
			</Box>
		</Grid >
	)
}

const PhotoSettings = () => {

	const axios = useAxiosPrivate()
	const theme = useTheme()
	const label = { inputProps: { 'aria-label': 'Switch demo' } };
	const [highResolution, setHighResolution] = useState({
		width: '',
		height: '',
		quality_level: '',
		dpi: '',
	})
	const [websize, setWebsize] = useState({
		width: '',
		height: '',
		quality_level: ''
	})
	const [check, setCheck] = useState(false)
	const [checked, setChecked] = useState(false)
	const [loadingImg, setLoadingImg] = useState([])
	const [showAlert, setShowAlert] = useState(false);
	const [isTransferring, setIsTransferring] = useState(false)
	const [deleteAllImages, setDeleteAllImages] = useState(false)
	const [editingPreference, setEditingPreference] = useState(false)
	const [userEditingPreferenceSwitch, setUserEditingPreferenceSwitch] = useState([])
	const [sampleImageObj, setSampleImageObj] = useState({})
	const [deleteSelected, setDeleteSelected] = useState([])
	const workSampleControllerRef = useRef(false)

	const handleChangeEvent = (event, setErrors, resetForm) => {
		setErrors({})
		resetForm()
		setCheck(event.target.checked)
	}
	const handleWebSizeEvent = (event, setErrors, resetForm) => {
		setErrors({})
		resetForm()
		setChecked(event.target.checked)
	}

	const validation = Yup.object({
		width: Yup.string()
			.required('width is required'),
		height: Yup.string()
			.required('height is required'),
		quality_level: Yup.string()
			.required('quality_level is required'),
		dpi: Yup.string()
			.required('dpi is required'),
	})

	const highResolutionDetails = useCallback(async () => {
		try {
			const resp = await axios.get('settings/high_resolution_details/')
			setHighResolution(resp.data.data.setting[0])
			setCheck(resp.data.data.setting[0].is_active)
		}
		catch (err) {
			console.error(err)
		}
	}, [axios])

	const websizeDetails = useCallback(async () => {
		try {
			const resp = await axios.get('settings/websize_details/')
			setWebsize(resp.data.data.setting[0])
			setChecked(resp.data.data.setting[0].is_active)
		}
		catch (err) {
			console.error(err)
		}
	}, [axios])

	const handleImageChange = async (e) => {
		let imageCount = loadingImg.length + e.target.files.length
		let imglist = Array.from(e.target.files)
		imglist = imglist.slice(0, 10 - loadingImg.length)
		setLoadingImg(prev => {
			imglist = [...prev, ...imglist.map(file => ({ file: file, status: 0, name: file.name }))]
			return imglist
		})
		for (let i = 0; i < imglist.length; i++) {
			setIsTransferring(true)
			const formdata = new FormData()
			formdata.append('media_type', 'image')
			formdata.append('image', imglist[i]['file'])
			if (imglist[i].status === 0) {
				try {
					const resp = await axios.post('settings/upload_work_sample/', formdata,
						{
							headers: {
								"Content-Type": "multipart/form-data",
							},
							signal: workSampleControllerRef.current.signal
						}
					)
					alertMsg(resp.data.message, "success")
					setLoadingImg(prev => {
						let img = [...prev]
						if (!!resp) {
							img[i] = { ...resp.data.data.work_sample, status: 1 }
						}
						return [...img]
					})
				}
				catch (e) {
					console.error("?? ~ file: PhotoSettings.jsx:102 ~ handleImageChange ~ e:", e)
				}
			}
		}
		setIsTransferring(false)
		if (imageCount > 10) {
			alertMsg("Work sample limit exceeded", 'error')
		}
	}

	const getSampleImages = async () => {
		try {
			const resp = await axios.get('settings/work_sample/')
			setLoadingImg(resp.data.data.work_sample)
		}
		catch (error) {
			console.error(error)
		}
	}

	const getavailableEditingPreference = async () => {
		try {
			const resp = await axios.get('settings/available_editing_preferences/', {
				params: {
					limit: 0
				}
			})
			setEditingPreference(resp.data.data.available_editing_preferences)
		}
		catch (error) {
			console.error(error)
		}

	}

	const handlePreferenceList = (e, preferenceId) => {
		if (e.target.checked) {
			setUserEditingPreferenceSwitch(prev => [...prev, preferenceId])
		}
		else
			setUserEditingPreferenceSwitch(prev => prev.filter(id => id !== preferenceId))
	}

	const userEditingPreference = async () => {
		try {
			const resp = await axios.post('settings/user_editing_preferences/', {
				preference_id: userEditingPreferenceSwitch
			})
			alertMsg(resp.data.message, 'success')
		}
		catch (error) {
			console.error(error)
		}
	}

	const getuserEditingPreference = async () => {
		try {
			const resp = await axios.get('settings/user_editing_preferences/')
			resp.data.data.base_preferences.map((data => setUserEditingPreferenceSwitch(prev => [...prev, data.preference_id])))
		}
		catch (error) {
			console.error(error)
		}
	}

	const deleteSampleImage = async (id) => {
		try {
			const resp = await axios.post("settings/delete_work_sample/", {
				work_sample_id_lst: id
			})
			getSampleImages()
			alertMsg(resp.data.message, "success")
			setDeleteSelected([])
		}
		catch (err) {
			console.error(err)
		}
	}
	useEffect(() => {
		workSampleControllerRef.current = new AbortController()
		highResolutionDetails();
		websizeDetails();
		getSampleImages();
		getavailableEditingPreference();
		getuserEditingPreference()
		return () => {
			workSampleControllerRef.current.abort()
		}
	}, [websizeDetails, highResolutionDetails]);

	const handleChange = (event, index, item) => {
		setDeleteSelected(
			prev => {
				if (!prev.includes(item.id)) {
					prev.push(item.id)
				}
				else {
					const position = deleteSelected.indexOf(item.id)
					if (position >= 0) {
						prev.splice(position, 1)
					}
				}
				return [...prev]
			}
		)
	}

	return (
		<div>
			<Container maxWidth="xl">
				<Box sx={{ mt: 3 }}>
					<Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Photo Settings</Typography>
				</Box>
				<Box sx={{ width: '100%', mt: 3, }}>
					{/* <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ justifyContent: "center" }}>
						<Grid item xs={12} lg={6}>
							<Card sx={{ p: { xs: 2, md: 3 }, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
								<CardContent sx={{ p: 0 }}>
									<Formik
										initialValues={{ ...highResolution }}
										enableReinitialize={true}
										validationSchema={validation}
										onSubmit={async (values, { setSubmitting }) => {
											try {
												const response = await axios.post("settings/high_resolution/", { ...values, is_active: check })
												alertMsg(response.data.message, 'success')
												setHighResolution(response.data.data.setting)
											}
											catch (error) {
												console.error(error)
											}
											setSubmitting(false);
										}}
									>
										{({ setErrors, resetForm }) => (
											<Form>
												<Box sx={{ display: "flex", justifyContent: "space-between" }}>
													<Box>
														<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}>High Resolution</Typography>
													</Box>
													<Box>
														<Field
															name="is_active"
															component={Switch}
															label={label}
															type="checkbox"
															checked={check}
															onChange={(e) => handleChangeEvent(e, setErrors, resetForm)}
														/>
													</Box>
												</Box>
												<Box sx={{ mt: 2 }}>
													<Typography sx={{ fontSize: { xs: 14, xl: 16 } }}>Select the dimensions and quality level you would like {BRAND_NAME} to deliver your print photos.</Typography>
												</Box>
												<Box sx={{ width: '100%', mt: 3 }}>
													<Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
														<Grid item xs={12} sm={6} md={3}>
															<Box>
																<StrictNumberField name="width" label="Width" size="small" inputProps={{ min: 0, }}
																	autoComplete='off' disabled={!check} component={TextField} type="number" fullWidth />
															</Box>
														</Grid>
														<Grid item xs={12} sm={6} md={3}>
															<Box>
																<StrictNumberField name="height" label="Height" size="small" disabled={!check}
																	autoComplete='off' inputProps={{ min: 0, }} component={TextField} type="number" fullWidth />
															</Box>
														</Grid>
														<Grid item xs={12} sm={6} md={3}>
															<Box >
																<Field
																	formControl={{ size: "small", fullWidth: true }}
																	label='Quality'
																	size="small"
																	name="quality_level"
																	component={Select}
																	disabled={!check}
																>
																	<MenuItem value={10}>10</MenuItem>
																	<MenuItem value={20}>20</MenuItem>
																	<MenuItem value={30}>30</MenuItem>
																</Field>
															</Box>
														</Grid>
														<Grid item xs={12} sm={6} md={3}>
															<Box>
																<StrictNumberField name="dpi" label="DPI" inputProps={{ min: 0, }} component={TextField} size="small"
																	autoComplete='off' disabled={!check} type="number" fullWidth />
															</Box>
														</Grid>
													</Grid>
												</Box>
												<CardActions sx={{ p: 0, justifyContent: "end", pt: 4 }}>
													<Button variant='outlined' size="small" type="submit" >Update</Button>
												</CardActions>
											</Form>
										)}
									</Formik>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} lg={6} sx={{ marginTop: { xs: 5, lg: 0 } }} >
							<Card sx={{ p: { xs: 2, md: 3 }, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }} >
								<CardContent sx={{ p: 0 }}>
									<Formik
										initialValues={{ ...websize }}
										enableReinitialize={true}
										validationSchema={
											Yup.object({
												width: Yup.string()
													.required('width is required'),
												height: Yup.string()
													.required('height is required'),
												quality_level: Yup.string()
													.required('quality_level is required'),
											})
										}
										onSubmit={async (values, { setSubmitting }) => {
											try {
												const response = await axios.post("settings/websize/", { ...values, is_active: checked })
												setWebsize(response.data.data.setting)
												alertMsg(response.data.message, 'success')
											}
											catch (error) {
												console.error(error)
											}
											setSubmitting(false);
										}}
									>
										{({ setErrors, resetForm }) => (
											<Form>
												<Box sx={{ display: "flex", justifyContent: "space-between" }}>
													<Box>
														<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}>Web Size</Typography>
													</Box>
													<Box>
														<Field
															name="is_active"
															component={Switch}
															label={label}
															type="checkbox"
															checked={checked}
															onChange={(e) => handleWebSizeEvent(e, setErrors, resetForm)}
														/>
													</Box>
												</Box>
												<Box sx={{ mt: 2 }}>
													<Typography sx={{ fontSize: { xs: 14, xl: 16 } }}>Select the dimensions and quality level you would like {BRAND_NAME} to deliver your web photos.</Typography>
												</Box>
												<Box sx={{ width: '100%', mt: 3 }}>
													<Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
														<Grid item xs={12} sm={6} md={3}>
															<Box>
																<StrictNumberField name="width" label="Width" size="small" disabled={!checked}
																	autoComplete='off' inputProps={{ min: 0, }} component={TextField} type="number" fullWidth />
															</Box>
														</Grid>
														<Grid item xs={12} sm={6} md={3}>
															<Box>
																<StrictNumberField name="height" label="Height" size="small" disabled={!checked}
																	autoComplete='off' inputProps={{ min: 0, }} component={TextField} type="number" fullWidth />
															</Box>
														</Grid>
														<Grid item xs={12} sm={6} md={3}>
															<Box >
																<Field
																	formControl={{ size: "small", fullWidth: true }}
																	label='Quality'
																	name="quality_level"
																	size="small"
																	component={Select}
																	disabled={!checked}
																>
																	<MenuItem value={10}>10</MenuItem>
																	<MenuItem value={20}>20</MenuItem>
																	<MenuItem value={30}>30</MenuItem>
																</Field>
															</Box>
														</Grid>
													</Grid>
												</Box>
												<CardActions sx={{ p: 0, justifyContent: "end", pt: 4 }}>
													<Button variant='outlined' size="small" type="submit" >Update</Button>
												</CardActions>
											</Form>
										)}
									</Formik>
								</CardContent>

							</Card>
						</Grid>

					</Grid> */}

					<Box sx={{ pt: 0 }}>
						<Card sx={{ p: { xs: 2, md: 3 }, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
							<CardContent sx={{ p: 0 }}>
								<Box sx={{ display: "flex", justifyContent: "space-between" }}>
									<Box>
										<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}>Editing Preferences</Typography>
									</Box>
									{/* <Box>
											<MuiSwitch {...label} />
										</Box> */}
								</Box>
								<Box sx={{ mt: 2 }}>
									<Typography sx={{ fontSize: { xs: 14, xl: 16 } }}>Select the options you would like to have on your photos by default.</Typography>
								</Box>


								{

									editingPreference.length > 0
										?
										<Box sx={{ width: '100%', mt: 3 }}>
											<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>

												{
													editingPreference
														?
														editingPreference.map((value, index) => {
															return (
																<Grid item xs={12} sm={6} md={4} key={index}>
																	<Box key={index}>
																		<FormControlLabel
																			control={
																				<MuiSwitch
																					checked={userEditingPreferenceSwitch.includes(value.id)}
																					onChange={(e) => { handlePreferenceList(e, value.id, index) }}
																				/>
																			}
																			label={value.name}
																		/>
																	</Box>
																</Grid>
															)
														})
														:
														<Box sx={{ height: "320px", background: "#ebecf0", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
															<CircularProgress />
														</Box>
												}

											</Grid>
										</Box>
										:
										<Empty sx={{ p: 6, textTransform: "capitalize" }} icon={<SettingsOutlinedIcon sx={{ fontSize: 30, color: "grey" }} />} text="no editing preferences available" />
								}

								<CardActions sx={{ p: 0, justifyContent: "end", pt: 4 }}>
									<Button variant='outlined' size="small" onClick={userEditingPreference}>Update</Button>
								</CardActions>

							</CardContent>
						</Card>
					</Box>
				</Box>

				<Box>
					<Box mt={6}>
						<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}>Sample Images</Typography>
					</Box>
				</Box>

				<Box sx={{ width: '100%', my: 3 }}>
					<Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ alignItems: "center" }}>
						<Grid item xs={12} lg={6}>
							<Box sx={{ height: "410px", border: "2px dashed grey", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 2 }}>
								<Box sx={{ textAlign: 'center' }}>
									<Box>
										<Button variant="outlined" component="label" size="large"
											startIcon={<CloudUploadOutlinedIcon />}
										>
											Image Upload
											<input hidden accept="image/*" multiple type="file" onChange={handleImageChange} />
										</Button>
									</Box>
									<Box sx={{ mt: 0.6 }}>
										<Typography sx={{ fontSize: 13, fontWeight: 500 }}>Maximum 10 images only can be uploaded</Typography>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} lg={6}>
							<Card sx={{ p: 3, bgcolor: theme.palette.mode === "dark" ? "background.dark" : "#fff", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }} >
								<CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
									<Box sx={{ flexGrow: 1, }}>
										<Grid container spacing={2} sx={{ alignItems: "center" }}>
											<Grid item xs={12} sm={1}>
												<Box sx={{ borderRight: { xs: "initial", sm: "1px solid grey" }, borderBottom: { xs: "1px solid grey", sm: "initial " } }}>
													<Typography sx={{ mb: { xs: "10px", sm: "0px" }, textAlign: { xs: "center", sm: "left", fontSize: "30px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>1</Typography>
												</Box>
											</Grid>
											<Grid item xs={12} sm={11}>
												<Box >
													<Box>
														<Typography sx={{ fontSize: "20px", textAlign: { xs: "center", sm: "left" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Upload</Typography>
													</Box>
													<Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
														<Typography sx={{ fontSize: "15px" }}>Upload Sample Images and attach them to your account.</Typography>
													</Box>
												</Box>
											</Grid>
										</Grid>
									</Box>
								</CardContent>
							</Card>
							<Card sx={{ p: 3, mt: 2, bgcolor: theme.palette.mode === "dark" ? "background.dark" : "#fff", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }} >
								<CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
									<Box sx={{ flexGrow: 1, }}>
										<Grid container spacing={2} sx={{ alignItems: "center" }}>
											<Grid item xs={12} sm={1}>
												<Box sx={{ borderRight: { xs: "initial", sm: "1px solid grey" }, borderBottom: { xs: "1px solid grey", sm: "initial " } }}>
													<Typography sx={{ mb: { xs: "10px", sm: "0px" }, textAlign: { xs: "center", sm: "left", fontSize: "30px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>2</Typography>
												</Box>
											</Grid>
											<Grid item xs={12} sm={11}>
												<Box >
													<Box>
														<Typography sx={{ fontSize: "20px", textAlign: { xs: "center", sm: "left" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Add description</Typography>
													</Box>
													<Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
														<Typography sx={{ fontSize: "15px" }}>Include a description about the sample image ( i.e "sky for sky replacement" or "logo for floor plans" ).</Typography>
													</Box>
												</Box>
											</Grid>
										</Grid>
									</Box>
								</CardContent>
							</Card>
							<Card sx={{ p: 3, mt: 2, bgcolor: theme.palette.mode === "dark" ? "background.dark" : "#fff", boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }} >
								<CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
									<Box sx={{ flexGrow: 1, }}>
										<Grid container spacing={2} sx={{ alignItems: "center" }}>
											<Grid item xs={12} sm={1}>
												<Box sx={{ borderRight: { xs: "initial", sm: "1px solid grey" }, borderBottom: { xs: "1px solid grey", sm: "initial " } }}>
													<Typography sx={{ mb: { xs: "10px", sm: "0px" }, textAlign: { xs: "center", sm: "left", fontSize: "30px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>3</Typography>
												</Box>
											</Grid>
											<Grid item xs={12} sm={11}>
												<Box >
													<Box>
														<Typography sx={{ fontSize: "20px", textAlign: { xs: "center", sm: "left" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Ready to use</Typography>
													</Box>
													<Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
														<Typography sx={{ fontSize: "15px" }}>When you submit a job, select the sample images that apply and we will do our best to match your style.</Typography>
													</Box>
												</Box>
											</Grid>
										</Grid>
									</Box>
								</CardContent>
							</Card>
						</Grid>


						<Grid container spacing={{ xs: 3 }} sx={{ justifyContent: 'center', pt: 5, }} style={{ marginLeft: "0px" }}>

							{loadingImg.map((item, index) => (
								// <Grid item key={index}  >
								<React.Fragment key={item.id}>
									{loadingImg[index].status === 0
										&&
										<Box>
											<Box sx={{ marginLeft: { xs: "8px !important", sm: "24px !important" }, marginTop: "24px", borderRadius: '5px', width: 280, height: "200px", background: "#e5e8f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
												<CircularProgress />
											</Box>
											{/* <Box sx={{ marginLeft: { xs: "8px !important", sm: "24px !important" }, marginTop: "24px", borderRadius: '5px', width: 310, height: "56px", background: "#e5e8f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
												<CircularProgress />
											</Box> */}
										</Box>
									}

									{
										(loadingImg[index].status === 1 || loadingImg[index].status === undefined)
										&&
										<WorkSample item={item}
											onDelete={() => {
												setShowAlert(true)
												setSampleImageObj({ ...item })
												setDeleteAllImages(false)
											}}

											isChecked={deleteSelected.includes(item.id)}
											checkBoxChange={
												(e) => {
													handleChange(e, index, item)
													console.log("e", e.target.checked, index, item)
												}
											}
											isTransferring={isTransferring}
										/>
									}
								</React.Fragment>
								// </Grid>
							))}

						</Grid>
					</Grid>
					<Box my={2}>
						{
							loadingImg.length > 0 && !isTransferring &&
							<Button sx={{ mr: 1, mb: { xs: 2, md: 0 } }} color='primary' variant="outlined"
								// sx={{ position: 'absolute', bottom: { xs: -50, sm: -70 } }}
								className='delete-selected-btn'
								onClick={() => {
									if (loadingImg.length === deleteSelected.length) {
										setDeleteSelected([])
										return
									}
									let ids = []
									for (let i = 0; i < loadingImg.length; i++) {
										ids.push(loadingImg[i].id)
									}
									setDeleteSelected(ids)
								}}
							>{loadingImg.length === deleteSelected.length ? "Unselect all" : "Select All"}</Button>
						}

						{
							deleteSelected.length > 0 && !isTransferring
							&&
							<Button color='error' variant="outlined"
								sx={{ mb: { xs: 2, md: 0 } }}
								className='delete-selected-btn'
								onClick={() => {
									setShowAlert(true)
									setDeleteAllImages(true)
								}}
							>Delete Selected ({deleteSelected.length})</Button>
						}

					</Box>

					<Popup show={showAlert} onSecondaryClick={() => { setShowAlert(false) }} title={"Delete Sample Images?"} consent={false} variant='error' primaryBtnTxt={"Delete"}
						onPrimaryClick={async (e, loader) => {
							if (e.detail !== 1) {
								return false
							}
							try {
								loader(true)
								if (deleteAllImages) {
									deleteSampleImage(deleteSelected)
									setShowAlert(false)
									setDeleteAllImages(false)
								}
								else {
									await deleteSampleImage([sampleImageObj.id])
									setShowAlert(false)
								}

								loader(false)
							}
							catch (error) {
								console.error(error)
							}
						}}
					>
						<Box sx={{ mt: 2, textAlign: "center" }}>
							<Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
								Are you sure you want to delete {deleteAllImages && loadingImg.length === deleteSelected.length && 'all'} this {deleteAllImages && deleteSelected.length > 1 && deleteSelected.length} sample images? </Typography>
						</Box>
						<Box sx={{ marginTop: "6px", textAlign: "center" }}>
							<Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
						</Box>
					</Popup>
				</Box>


			</Container>
		</div >
	)
}

export default PhotoSettings
